import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'user-register';
export const route = 'user-register/';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import('../components/RegisterPage')));